<template>
  <div class="column-view center-view padding-10">
    <div class="main">
      <div class="row-view center-view margin-bottom-10">
        <el-button @click="onPrinting" class="margin-right-15" v-if="false"
          >下一张</el-button
        >

        <el-button @click="onPrinting">一键打印</el-button>
        <el-button @click="onDownload">一键下载</el-button>
      </div>

      <div class="page">
        <div id="page" class="column-view">
          <div
            v-for="(item, index) in list"
            :key="index"
            style="width: 100%; font-family: STKaiti"
            class="column-view"
            ref="pdfItem"
            :class="{ 'simulate-a4': isDownload }"
          >
            <!--顶部文件区域-->
            <div
              style="
                display: flex;
                flex-direction: column;
                padding-top: 20px;
                padding-left: 50px;
                padding-right: 50px;
              "
            >
              <h2 style="width: 100%; text-align: center" class="margin-top-20">
                {{
                  "山西局" + (year || "2025") + "年年度考核线上测评系统使用说明"
                }}
              </h2>

              <p
                style="
                  font-size: 21px;
                  text-indent: 2em;
                  line-height: 2;
                  margin-block-start: 0;
                  margin-block-end: 0;
                  margin-top: 35px;
                "
              >
                {{
                  (year || "2025") +
                  "年年度考核采用线上测评的方式进行。线上测评通过扫描二维码匿名开展，请客观公正、实事求是地开展考核测评工作。有关事项说明如下："
                }}
              </p>

              <p
                style="
                  font-size: 21px;
                  text-indent: 2em;
                  line-height: 2;
                  margin-block-start: 0;
                  margin-block-end: 0;
                "
              >
                <span style="display: inline-block; width: 1em; text-indent: 0"
                  >1.</span
                >
                <span>请使用</span>
                <strong>微信扫描(推荐方式)</strong>
                <span>或手机浏览器分配给您的二维码进入评议界面。</span>
              </p>

              <p
                style="
                  font-size: 21px;
                  text-indent: 2em;
                  line-height: 2;
                  margin-block-start: 0;
                  margin-block-end: 0;
                "
              >
                <span style="display: inline-block; width: 1em; text-indent: 0"
                  >2.</span
                >
                <span
                  >请逐表逐项进行评议，每张表测评完成可点击最下面的"立即提交"按钮，确定后将跳转至系统首页继续进行评议。</span
                >
              </p>
              <p
                style="
                  font-size: 21px;
                  text-indent: 2em;
                  line-height: 2;
                  margin-block-start: 0;
                  margin-block-end: 0;
                "
              >
                <span style="display: inline-block; width: 1em; text-indent: 0"
                  >3.</span
                >
                <span
                  >只有测评表所有项目均进行评议后，系统方能完成提交，若评议界面出现"评测项目:未填选项"页面或"存在未填选项请核查"页面时，说明此表有未填的选项，需返回完成所有评议项目。</span
                >
              </p>

              <p
                style="
                  font-size: 21px;
                  text-indent: 2em;
                  line-height: 2;
                  margin-block-start: 0;
                  margin-block-end: 0;
                "
              >
                <span style="display: inline-block; width: 1em; text-indent: 0"
                  >4.</span
                >
                <span
                  >评议完成1张测评表后，该表按钮即呈现灰色(表示评议完成)。</span
                >
                <strong>每一张测评表完成提交后，将无法修改。</strong>
              </p>

              <p
                style="
                  font-size: 21px;
                  text-indent: 2em;
                  line-height: 2;
                  margin-block-start: 0;
                  margin-block-end: 0;
                "
              >
                <span style="display: inline-block; width: 1em; text-indent: 0"
                  >5.</span
                >
                <span
                  >所有评议完成提交成功之后首页所有测评表按钮呈灰色，请务必确认显示该界面，完成所有测评表的评议。</span
                >
              </p>
              <p
                style="
                  font-size: 21px;
                  text-indent: 2em;
                  line-height: 2;
                  margin-block-start: 0;
                  margin-block-end: 0;
                "
              >
                <span>请按时完成线上测评，过时将关闭测评系统。</span>
              </p>
            </div>

            <!--底部二维码区域-->
            <div
              style="
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding-bottom: 10px;
              "
            >
              <vue-qrcode
                :value="item.code"
                :options="{ width: 200 }"
              ></vue-qrcode>
              <!--              <p style="font-size: 21px;line-height: 2;margin-block-start:0;margin-block-end: 0;visibility: visible">-->
              <!--                <span>{{item.name}}</span>-->
              <!--              </p>-->
              <!--              <span style="visibility: visible">{{item.dept}}</span>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import printJS from "print-js";
import VueQrcode from "@chenfengyuan/vue-qrcode";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  name: "Print",
  data() {
    return {
      year: "",
      qrCode: "",
      name: "",
      dept: "",
      codeDes: "",
      isDownload: false,
      meeting_name: "",

      list: [],
      //{}
    };
  },
  components: {
    VueQrcode,
  },
  created() {
    let data = this.$route.query;
    this.year = data.year;
    this.meeting_name = data.meeting_name;
    this.list = JSON.parse(data.list);
  },
  methods: {
    onPrinting() {
      // this.remove_ie_header_and_footer();
      printJS({
        printable: "page", // 要打印内容的id
        type: "html", // 可以打印html,img详细的可以在官方文档https://printjs.crabbly.com/中查询
        scanStyles: false,
      });
    },

    async onDownload() {
      this.isDownload = true;

      this.$commonUtils.showMessage("正在下载，请稍候～", "success");
      await this.$nextTick();

      const zip = new JSZip();
      const doms = this.$refs.pdfItem;

      try {
        // 遍历所有 DIV
        for (let i = 0; i < doms.length; i++) {
          const dom = doms[i];

          // 1. 将 DOM 转换成 canvas
          // scale: 2 保证图片清晰度（相当于二倍图）
          const canvas = await html2canvas(dom, {
            scale: 2,
            useCORS: true, // 允许跨域图片
            logging: false,
            backgroundColor: "#ffffff", // 确保背景是白色的
          });

          const a4Width = 595.28;
          const a4Height = 841.89;

          // 2. 计算尺寸
          const contentWidth = a4Width;
          const contentHeight = (a4Width / canvas.width) * canvas.height;

          // 3. 创建 PDF
          // 这里的单位是 pt。
          // 如果你想生成标准 A4，需要经过复杂的计算缩放。
          // 为了"格式不变"，这里直接按内容原本大小生成 PDF 页面。
          const pdf = new jsPDF("p", "pt", [contentWidth, contentHeight]);

          // 4. 将 Canvas 转为图片数据
          const imgData = canvas.toDataURL("image/jpeg", 1.0);

          // 5. 图片放入 PDF (x, y, w, h)
          pdf.addImage(imgData, "JPEG", 0, 0, contentWidth, contentHeight);

          // 6. 转为 blob 并存入 zip
          const pdfBlob = pdf.output("blob");
          zip.file(`${this.list[i].fileName}.pdf`, pdfBlob);
        }

        // 7. 打包下载
        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `${this.meeting_name}-测评表.zip`);
        this.$commonUtils.showMessage("导出成功～", "success");
      } catch (error) {
        console.error("导出出错", error);
        this.$commonUtils.showMessage("导出失败～", "error");
      } finally {
        this.isDownload = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 1200px;
  margin: 0 auto;
  padding: 15px;
  border-radius: 10px;
  background-color: #eeeeee;
}

.page {
  width: 100%;
  padding: 15px;
  background: white;
  border-radius: 10px;
}

.simulate-a4 {
  /* A4 纸在 96DPI 下的像素宽度约为 794px */
  /* 设置为 fixed width，强制内容按 A4 宽度换行 */
  width: 794px !important;

  /* 也可以限制最小高度，模拟一张纸的样子 */
  min-height: 1123px;

  /* 稍微调整下内边距，模拟打印页边距 */
  padding: 30px 40px !important;

  /* 确保背景白底 */
  background: #ffffff !important;

  /* 必须保证文字颜色是黑的，防止打印看不清 */
  color: #000 !important;

  /* 甚至可以把这一块居中，或者脱离文档流，避免影响页面其他元素 */
  margin: 0 auto;
}
</style>
